"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Title: true
};
exports.default = exports.Title = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _Title = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title.css") : void 0);
var _Title2 = require("./Title.types");
Object.keys(_Title2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Title2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Title2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-title';
/**
 * The **Title** component provides a way to make headings accessible by
 * separating the heading tag from the heading style, allowing for more
 * flexibility in design while still adhering to accessibility best practices.
 *
 * As a general accessibility rule, it's not ideal to truncate text.  There are
 * certain circumstances, however, that do necessitate a truncation pattern.
 * In cases like this, consult the CSS Helper Mixins patterns:
 * - [Text Overflow](./?path=/docs/patterns-css-helper-mixins--docs#text-overflow)
 * - [Text Overflow
 * Clamp](./?path=/docs/patterns-css-helper-mixins--docs#text-overflow-clamp)
 */
const Title = exports.Title = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      className,
      children,
      headingLevel,
      headingStyle,
      overrideFontFamily
    } = props,
    otherProps = __rest(props, ["className", "children", "headingLevel", "headingStyle", "overrideFontFamily"]);
  const classnames = _bind.default.bind(_Title.default);
  const headingClassTag = headingStyle ? `h${headingStyle}` : `h${headingLevel}`;
  const classes = classnames(CSS_BLOCK, `${CSS_BLOCK}--${headingClassTag}`, {
    [`${CSS_BLOCK}--${overrideFontFamily}`]: !!overrideFontFamily
  }, className);
  const HeadingTagValue = `h${headingLevel}`;
  return /*#__PURE__*/_react.default.createElement(HeadingTagValue, Object.assign({}, otherProps, {
    className: classes,
    ref: ref
  }), children);
});
Title.displayName = 'Title';
var _default = exports.default = Title;